import React from 'react';

import {Link} from '@vw-marketing/us-components';

import {NewDownloadIcon} from '../icons/NewDownloadIcon';
import {onVWBasicDownloadClick} from '../../tagging/tagging-helpers';
import {StyledBrochureWrapper, StyledText} from './styles';
import {UsedVehicle} from '../../typing/used-inventory';
import {useTrackingManager} from '../../hooks/use-tracking-manager';

interface BrochureProps {
  readonly text?: string;
  readonly url?: string;
  readonly vehicleData?: UsedVehicle;
}
const Brochure = ({text, url, vehicleData}: BrochureProps) => {
  const trackingManager = useTrackingManager();

  const handleOnClick = () => {
    const linkData = {
      url: url ? url : undefined,
      name: text ? text : undefined,
      newTab: true,
    };

    const fileData = {
      name: undefined,
      category: 'car brochure',
      type: 'pdf',
      productName: vehicleData?.model,
      url: url ? url : undefined,
      language: 'en',
    };

    trackingManager &&
      onVWBasicDownloadClick(linkData, fileData, trackingManager, vehicleData);
  };

  return (
    <StyledBrochureWrapper>
      <StyledText>
        {/* @ts-ignore */}
        <Link isInline target="_blank" href={url} onClick={handleOnClick}>
          {text}
        </Link>
      </StyledText>
      <NewDownloadIcon width="24" height="24" />
    </StyledBrochureWrapper>
  );
};

export default Brochure;
